module.exports = __webpack_public_path__ + "img/monarch-ui-icon_ANATOMY.dfa2358b.png";